import { DrawerHeader } from '@chakra-ui/react'
import { mdiTrashCanOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import DrawerDialog from '@/components/drawer'
import { Box } from '@/components/ui/box'
import { Button } from '@/components/ui/button'
import { DrawerBody, DrawerFooter } from '@/components/ui/drawer'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'

const DeleteConversationDrawer = ({ isOpen, onClose, onDelete }: { isOpen: boolean; onClose: () => void; onDelete: () => void }) => {
    const { t } = useTranslation()
    const borderColor = useColorModeValue('gray.300', 'gray.700')

    return (
        <DrawerDialog isOpen={isOpen} onClose={onClose}>
            <DrawerHeader borderBottomWidth="1px" borderColor={borderColor} px="0" py="24px">
                <Box display="flex" alignItems="center">
                    <Icon path={mdiTrashCanOutline} size={1} />
                    <Text ml="18px">{t('chat.deleteConversation.drawer.title')}</Text>
                </Box>
            </DrawerHeader>
            <DrawerBody px="0" py="24px">
                <Text fontSize={14} fontWeight="bold">
                    {t('chat.deleteConversation.drawer.content_1')}
                </Text>
                <Text fontSize={14} fontWeight="bold">
                    {t('chat.deleteConversation.drawer.content_2')}
                </Text>
            </DrawerBody>
            <DrawerFooter borderTopWidth="1px" borderColor={borderColor} justifyContent="flex-start" px="0" py="32px">
                <Button variant="secondary" mr="18px" onClick={onClose}>
                    {t('chat.deleteConversation.drawer.buttons.cancel')}
                </Button>
                <Button
                    variant="primary"
                    onClick={() => {
                        onDelete()
                        onClose()
                    }}
                >
                    {t('chat.deleteConversation.drawer.buttons.send')}
                </Button>
            </DrawerFooter>
        </DrawerDialog>
    )
}

export default DeleteConversationDrawer
